<template>
    <div>
        <v-hover v-slot="{ hover }" open-delay="200">
            <div>
                <v-expand-transition>
                    <crm-entry-menu
                        :entry    = "entry"
                        v-if      = "hover"
                        @edit     = "onEdit"
                        @delete   = "onDelete"
                        @undelete = "onUndelete"
                    />
                </v-expand-transition>

                <div class="card-info-title crm-title" style="justify-content: space-between">
                    <div class="v-flex">
                        <v-icon
                            v-if="entry.type.font"
                            class  = "crm-journal-icon"
                            :class = "titleTextColor"
                        >
                            {{ entry.type.font }} {{ 'fa-' + entry.type.symbol }}
                        </v-icon>
                        <v-icon
                            v-if="!entry.type.font"
                            class  = "crm-journal-mdi-icon"
                            :class = "titleTextColor"
                            :size   = "20"
                        >
                            {{ entry.type.symbol }}
                        </v-icon>
                        <div
                            class  = "card-info-text crm-date"
                            :class = "textColor"
                        >
                            {{ dateAsString (entry.time !== null ? entry.time : entry.createdDate) }}
                        </div>
                    </div>
                    <div
                        class  = "crm-avatar"
                        :class = "textColor"
                    >
                        {{ dateAsString(entry.modifiedDate) + " - " + (entry.modifiedBy ? entry.modifiedBy : entry.user ? entry.user.ident : '') }}
                    </div>
                </div>

                <div
                    class  = "card-info-text crm-subtitle"
                    :class = "titleTextColor"
                >
                    {{ subject }}
                </div>

                <div class="v-flex"  v-if="entry.partner.name">
                    <v-icon
                        class="crm-journal-icon"
                        :class = "textColor"
                    >
                        fas fa-user-tie
                    </v-icon>
                    <div
                        class="card-info-text crm-partner"
                        :class = "textColor"
                    >
                        {{ entry.partner.name }}
                    </div>
                </div>

                <div
                    class="card-info-text crm-email"
                    :class = "textColor"
                >
                    {{ entry.partner.email }}
                </div>

                <div
                    class  = "card-info-text crm-description"
                    :class = "entry.deleted?'red--text':''"
                    v-html = "entry.description"
                >
                </div>
            </div>
        </v-hover>
    </div>
</template>

<script>

import Core         from "@/modules/core/service/Core";
import Crm          from "@/modules/crm/service/Crm.ts";
import CrmEntryMenu from "@/modules/crm/components/main/CrmEntryMenu";

export default {
    name: "CrmEntryReadonly",

    components: {
        CrmEntryMenu
    },

    props: {
        entry: {
            required: true,
            type    : Object
        },

        incident: {
            required: true,
            type    : Object
        }
    },

    data () {
        return {
            confirm: false,
        }
    },

    computed: {
        titleTextColor () {
            return this.entry.deleted ? 'error--text' : 'primary--text';
        },

        textColor () {
            return this.entry.deleted ? 'error--text' : '';
        },

        subject () {
            if (!this.entry.subject) {
                return null;
            }

            const translated = this.entry.subject.startsWith("journal.") ? this.$t(this.entry.subject) : null;
            if (!translated) {
                return this.entry.subject;
            }

            return translated;
        },
    },

    methods: {
        dateAsString (value) {
            return Core.format.datetime.display(value);
        },

        onEdit  () {
            this.$emit(Crm.events.edit, this.entry);
        },

        onDelete () {
            Core.message.confirm(
                this,
                this.$t('crm.confirm.delete'),
                null,
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }
                    Crm.delete(this.entry.id, () => {
                        this.$emit(Crm.events.deleted);
                        this.confirm = false;
                    })
            });
        },

        onUndelete () {
            Core.message.confirm(
                this,
                this.$t('crm.confirm.undelete'),
                null,
                Core.message.Default,
                (value) => {
                    if (!value) {
                        return;
                    }

                    this.entry.incident.id = this.incident.id;
                    this.entry.incident.sites = this.incident.sites;

                    Crm.save(this.entry.type.id, this.entry, () => {
                        this.freeze = JSON.stringify(this.entry);
                        this.$emit(Crm.events.undeleted);
                        this.confirm = false;
                    })
            });
        },
    }
}
</script>

<style scoped>

.crm-journal-icon {
    font-size: 15px !important;
    margin-top: -1px;
    margin-right: 5px!important;
}

.crm-journal-mdi-icon {
    margin-top: -1px;
    margin-right: 3px!important;
}

.crm-title i {
    font-size: 14pt;
    margin-right: 2px;
}


.crm-description {
    padding-left: 23px;
    white-space: pre-line;
    max-height: 200px;
    overflow-y: scroll;
}

.crm-partner {
    margin-left: 9px;
    overflow: hidden;
}

.crm-email {
    font-size: 10px;
    margin-left: 25px;
    overflow: hidden;
}

.crm-avatar {
    font-size: 8pt;
}

.crm-title {
    display: flex;
    width: 100%;
}

.crm-subtitle {
    width: calc(100% - 23px);
    margin-left: 23px;
}

::v-deep .v-input__icon--clear {
    margin-right: -3px;
}


</style>